<template>
  <div class="calendar-range">
    <div class="months-list">
      <CalendarMonth
          v-for="month in monthList"
          :availabe-dates="[]"
          :key="month"
          :month-date="month"
          :from="selected.from.unix"
          :to="selected.to.unix"
          :price="props.minPrice"
          :filter-dates="true"
          :availableDates="availableDates"
          @date-click="onDateClick"
      />
    </div>
    <button class="btn btn-tertiary btn-icon btn-size-l button-previous" @click="changeMonth(-1)">
      <span class="icon icon-chevron-left color-dark-grey"/>
    </button>
    <button class="btn btn-tertiary btn-icon btn-size-l button-next" @click="changeMonth(1)">
      <span class="icon icon-chevron-right color-dark-grey"/>
    </button>
  </div>
</template>

<script setup lang="ts">
import dayjs from '~/utils/dayjs'
import {useSearchStore} from "~/store/search";
const { t } = useI18n()

const searchStore = useSearchStore()
const props = defineProps({minPrice: {type: String, default: ''}})
const emit = defineEmits(['dateChanged', 'close'])
const monthList = ref([] as any[])
const selected = ref({from: {value: '', unix: 0}, to: {value: '', unix: 0}})
const monthCount = 1
let startDate: any = null
let monthModifier = 0
const availableDates = computed(() => searchStore.activityAvailableDates)

function makeMonthsList() {
  monthList.value = []
  for (let i = 0; i < monthCount; i++) {
    monthList.value.push(startDate.add(monthModifier + i, 'month').format('YYYY-MM-DD'))
  }
}

function onDateClick(date: any) {
  const from = selected.value.from
  if (!from.value) {
    from.value = date.value
    from.unix = date.unix
  } else if (from.value) {
    from.value = ''
    from.unix = 0

    // from.value = date.value
    // from.unix = date.unix
  }
  emit('dateChanged', from.value || null)
}

function getDates() {
  if (searchStore.dates[0]) {
    selected.value.from.value = searchStore.dates[0]
    selected.value.from.unix = dayjs(searchStore.dates[0]).unix()
  }
  if (searchStore.dates[1]) {
    selected.value.to.value = searchStore.dates[1]
    selected.value.to.unix = dayjs(searchStore.dates[1]).unix()
  }
}

function changeMonth(diff: number) {
  monthModifier += diff
  makeMonthsList()
}

function checkFirstMonth() {
  const currentMonth = dayjs().startOf('month')
  if (selected.value.from?.value) {
    const suggestedMonthFrom = dayjs(selected.value.from?.value).startOf('month')
    const suggestedMonthTo = dayjs(selected.value.to?.value).startOf('month')
    if (suggestedMonthFrom.diff(suggestedMonthTo, 'month') === 0) {
      const diff = suggestedMonthFrom.diff(currentMonth, 'month')
      startDate = diff > 0 ? suggestedMonthFrom.subtract(1, 'month') : currentMonth
    } else {
      startDate = suggestedMonthFrom
    }
  } else {
    startDate = currentMonth
  }
}

getDates()
checkFirstMonth()
makeMonthsList()

</script>

<style lang="scss" scoped>
.calendar-range {
  padding: 16px 16px 0;
  position: relative;
  .months-list {
    display: flex;
    gap: 24px;
  }
  .bottom-block {
    text-align: center;
    button {
      width: 100%;
    }
  }
  .button-previous {
    position: absolute;
    top: 16px;
    left: 16px;
  }
  .button-next {
    position: absolute;
    top: 16px;
    right: 16px;
  }
}
</style>
